import { BaseModel } from '@cotera/client/v0/actions/framework/model.base';
import { useStatefullyAwareInScopeModel } from '@cotera/client/v0/actions/framework/use-in-scope-model';
import { Watchable } from '@cotera/client/v0/actions/framework/watchable';

/**
 * View model for the artifact side panel (expand/collapse, layout chrome).
 * Registered by {@link ArtifactSidePanel} while the panel is mounted.
 */
export class ArtifactPanelModel extends BaseModel {
  readonly isExpandedWatchable: Watchable<boolean> = Watchable.fromValue(false);
  readonly canExpandWatchable: Watchable<boolean> = Watchable.fromValue(false);

  constructor() {
    super('artifact-panel');
  }

  setCanExpand(canExpand: boolean): void {
    if (this.canExpandWatchable.snapshot() === canExpand) {
      return;
    }
    this.canExpandWatchable.set(canExpand);
    if (canExpand === false && this.isExpandedWatchable.snapshot()) {
      this.setExpanded(false);
    }
  }

  setExpanded(expanded: boolean): void {
    if (!this.canExpandWatchable.snapshot() && expanded) {
      return;
    }
    if (this.isExpandedWatchable.snapshot() === expanded) {
      return;
    }
    this.isExpandedWatchable.set(expanded);
  }

  toggleExpanded(): void {
    this.setExpanded(!this.isExpandedWatchable.snapshot());
  }

  expand(): void {
    this.setExpanded(true);
  }

  collapse(): void {
    this.setExpanded(false);
  }
}

export const useArtifactPanelModel = (): ArtifactPanelModel | null =>
  useStatefullyAwareInScopeModel(ArtifactPanelModel);
